import Button from '@carvana/ds-button';
import { datadogRum } from '@datadog/browser-rum';
import { useContext, useEffect } from 'react';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import InventoryContext from '~/context/srp/InventoryContext';
import SearchErrorIcon from '~/icons/srp/SearchError';

export default function ErrorSection() {
  const trackEvent = useTrackEvent();
  const { triggerFetchSearch } = useContext(InventoryContext);

  useEffect(() => {
    trackEvent('Search Error Shown');

    datadogRum.addAction('Search Error Shown');
  }, [trackEvent]);

  return (
    <div
      className="flex flex-col items-center justify-center gap-2xl py-xl"
      data-testid="search-error-wrapper"
      role="alert"
    >
      <SearchErrorIcon />
      <div className="flex flex-col items-center gap-lg">
        <div className="text-text-strong t-heading-lg sm:t-heading-xl">
          Oops, something went wrong
        </div>
        <div className="text-center text-text-default t-body-sm">
          Try refreshing to see if that fixes the problem
        </div>
      </div>
      <Button
        className="w-full sm:w-fit"
        variant="primary"
        size="md"
        data-adobe-id="search-error-refresh"
        data-testid="search-error-refresh"
        data-analytics-id="search-error-refresh-button"
        onClick={triggerFetchSearch}
      >
        Refresh
      </Button>
    </div>
  );
}
